import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryInputQuantity extends BaseWasmQuery {
    toPayload() {
        return toBase64({
            get_input_quantity: {
                to_quantity: this.params.toQuantity,
                source_denom: this.params.sourceDenom,
                target_denom: this.params.targetDenom,
            },
        });
    }
}
